// extracted by mini-css-extract-plugin
export default {"title":"_6411e370ae","bld":"_77b1348349"};